import JSX from "./../../../helpers/react.js";
import RefObject = JSX.RefObject;
import { IOneMessageJson } from "../../../../../../nodeserver/structs/database.js";
import { canChangeOrSeeMessage, hasSpecialActions } from "../../../messages/helpers.js";
import { hideUserMessageActionsDetails } from "../user-actions.js";
import { ServerApi } from "../../../api.js";
import { handleFetchError } from "../../../helpers/functions.js";

export function DeleteActionElement(props:{
    msg: IOneMessageJson,
    message: RefObject<HTMLDivElement>,
    withText: boolean
}){
    const userFromId = props.msg.from_id;
    const isDeleted = props.msg.deleted;
    const lastDeletedById = props.msg.deleted_by_id;
    
    const deleteElement = !isDeleted && hasSpecialActions(userFromId) && canChangeOrSeeMessage(lastDeletedById) ? (
        <div className="action-element"
             onClick={e => deleteMessageClickEventHandler(e, props.message.value!)}
        >
            <div className="message-action-padding">
                <img src="/img/delete-message.svg" className="action-element-img"/>
            </div>
            
            {!!props.withText && <div className="message-action-padding main-red-font">Удалить</div>}

        </div>
    ) : <></>;
    return deleteElement;

    
}

export async function deleteMessageClickEventHandler(
    event: MouseEvent & {
        target: HTMLElement
    },
    message: HTMLDivElement
) {

    try {
        await ServerApi.messages.deleteMessage(+message.dataset.id!);
        hideUserMessageActionsDetails(message);

    } catch (e) {
        handleFetchError(e);
    }
}
